import { Stack } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFileInvoiceDollar } from "@fortawesome/pro-light-svg-icons"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { MERCHANT_ACCOUNTING_ROUTE } from "../../../../../constants/routes"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { StandardTabs } from "../../../../../shared/components/tabs/StandardTabs"
import { AccountingOrdersTab, OrderAccountingTab } from "../components/OrderAccountingTab"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { MeetingServiceAccountingTab } from "../components/MeetingServiceAccountingTab"

export function Orders() {
    const { l10n } = useAppLocalization()
    const tabs = [
        {
            label: l10n.getString("accounting-orders-tab-meetingService"),
            component: <MeetingServiceAccountingTab />,
        },
        {
            label: l10n.getString("accounting-orders-tab-transactions"),
            component: <OrderAccountingTab tabQueryParam={AccountingOrdersTab.TRANSACTIONS} />,
        },
        {
            label: l10n.getString("accounting-orders-tab-refill"),
            component: <OrderAccountingTab tabQueryParam={AccountingOrdersTab.REFILL} />,
        },
    ]

    return (
        <>
            <LocalizedStrict id="accounting-orders-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.ACCOUNTING_ORDERS}
                    title="Orders"
                    icon={<FontAwesomeIcon icon={faFileInvoiceDollar} />}
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_ACCOUNTING_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>

                        <LocalizedStrict id="merchant-nav-item-accounting">
                            <Breadcrumb>Accounting</Breadcrumb>
                        </LocalizedStrict>

                        <LocalizedStrict id="accounting-orders-breadcrumb-title">
                            <Breadcrumb>Orders</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <Stack position="relative">
                <StandardTabs tabs={tabs} />
            </Stack>
        </>
    )
}
